import {
	PROCESS_ORDER,
	GENERATE_ORDER,
	GET_ORDER,
	UPDATE_ORDER_COMMENTS,
	UPDATE_ORDER_INTERNAL_NUM,
	UPDATE_ORDER_PRODUCT_AVAILABILITY,
	UPDATE_ORDER_PRODUCT_SHIPPINGDATE,
	UPDATE_ORDER_PRODUCT_QTY,
	UPDATE_ORDER_PRODUCT_VALIDATION,
	ORDER_DELIVERY_TYPE_CHANGE,
	RESET_ORDER_COMPLETED,
	RESET_ORDER_ERROR
} from '@/redux/actions/order.actions'

const initialState = {
	loading: false,
	isCreating: false,
	error: {
		status: false,
		data: null
	},
	details: null,
	completed: null
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case GENERATE_ORDER.REQUEST:
		case GENERATE_ORDER.SUCCESS:
		case PROCESS_ORDER.REQUEST:
		case PROCESS_ORDER.SUCCESS:
		case RESET_ORDER_ERROR:
			return { status: false, data: null }
		case GENERATE_ORDER.FAILURE:
			return { status: true, data: null }
		case PROCESS_ORDER.FAILURE: {
			return {
				status: true,
				data: action.payload
			}
		}
		default:
			return state
	}
}

const completed = (state = initialState.completed, action) => {
	switch (action.type) {
		case PROCESS_ORDER.REQUEST:
		case RESET_ORDER_COMPLETED:
		case GENERATE_ORDER.REQUEST:
		case GENERATE_ORDER.SUCCESS:
		case GENERATE_ORDER.FAILURE:
			return null
		case PROCESS_ORDER.SUCCESS:
			return true
		case PROCESS_ORDER.FAILURE:
			return false
		default:
			return state
	}
}

const isCreating = (state = initialState.isCreating, action) => {
	switch (action.type) {
		case PROCESS_ORDER.REQUEST:
			return true
		case PROCESS_ORDER.SUCCESS:
		case PROCESS_ORDER.FAILURE:
			return false
		default:
			return state
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case GENERATE_ORDER.REQUEST:
		case PROCESS_ORDER.REQUEST:
			return true
		case GENERATE_ORDER.SUCCESS:
		case PROCESS_ORDER.SUCCESS:
		case GENERATE_ORDER.FAILURE:
		case PROCESS_ORDER.FAILURE:
			return false
		default:
			return state
	}
}

const details = (state = initialState.details, action) => {
	switch (action.type) {
		case GENERATE_ORDER.REQUEST:
		case GENERATE_ORDER.FAILURE:
		case GET_ORDER.REQUEST:
		case GET_ORDER.FAILURE:
			return null
		case GET_ORDER.SUCCESS:
			return action.payload
		case GENERATE_ORDER.SUCCESS:
			return {
				...action.payload.order,
				sendTogether: 0,
				products: action.payload.order.products.reduce((acc, product) => {
					const projectProduct = action.payload.project.products.find(projectProduct => projectProduct._id === product._id)

					if (!projectProduct?.orderAvailable.valid) {
						return acc
					}

					const moq = projectProduct.orderAvailable.moq[0]?.moq

					return {
						orderedIds: [...acc.orderedIds, product._id],
						byId: {
							...acc.byId,
							[product._id]: {
								...product,
								moq,
								isDiscontinued: projectProduct?.isDiscontinued || false
							}
						},
						byType: {
							...acc.byType,
							[product.type]: acc.byType[product.type] ? [...acc.byType[product.type], product._id] : [product._id]
						}
					}
				}, { orderedIds: [], byId: {}, byType: {} })
			}
		case UPDATE_ORDER_COMMENTS:
			return {
				...state,
				comments: action.payload.comments
			}
		case UPDATE_ORDER_INTERNAL_NUM:
			return {
				...state,
				internalOrderNumber: action.payload.text
			}
		case ORDER_DELIVERY_TYPE_CHANGE: {
			return {
				...state,
				sendTogether: action.payload.sendTogether
			}
		}
		case UPDATE_ORDER_PRODUCT_AVAILABILITY:
			return {
				...state,
				products: {
					...state.products,
					byId: {
						...state.products.byId,
						[action.payload.productId]: {
							...state.products.byId[action.payload.productId],
							availability: action.payload.availability
						}
					}
				}
			}
		case UPDATE_ORDER_PRODUCT_SHIPPINGDATE:
			return {
				...state,
				products: {
					...state.products,
					byId: {
						...state.products.byId,
						[action.payload.productId]: {
							...state.products.byId[action.payload.productId],
							availability: {
								...state.products.byId[action.payload.productId].availability,
								shipping: action.payload.date
							}
						}
					}
				}
			}
		case UPDATE_ORDER_PRODUCT_QTY:
			return {
				...state,
				products: {
					...state.products,
					byId: {
						...state.products.byId,
						[action.payload.productId]: {
							...state.products.byId[action.payload.productId],
							quantity: action.payload.quantity,
							prices: {
								...state.products.byId[action.payload.productId].prices,
								totalGross: state.products.byId[action.payload.productId].prices.unitGross * action.payload.quantity,
								totalNet: state.products.byId[action.payload.productId].prices.unitNet * action.payload.quantity
							}
						}
					}
				}
			}
		case UPDATE_ORDER_PRODUCT_VALIDATION:
			return {
				...state,
				products: {
					...state.products,
					byId: {
						...state.products.byId,
						[action.payload.productId]: {
							...state.products.byId[action.payload.productId],
							validation: {
								status: action.payload.validation.status
							}
						}
					}
				}
			}
		default:
			return state
	}
}

export default {
	name: 'order',
	reducers: {
		loading,
		error,
		details,
		completed,
		isCreating
	}
}
